import language from './languages'
const speedImg = 'images/speed.png'
const deleteDocImg = 'images/delete_document.png'
const customerImg = 'images/customer.png'
const dataProtectImg = 'images/protect.png'
const formImg = 'images/form.png'
const uploadImg = 'images/upload.png'
const kycImg = 'images/verified.png'
const cashImg = 'images/cash.png'
const flexibleImg = 'images/flexible.png'

const base_url = {
    media_server_url: 'https://image.prettysecrets.com/media'
}

const media_base_url = {
    ps_product_image_url: base_url.media_server_url + '/catalog/product',
    ps_icons_image_url: base_url.media_server_url + '/icons',
    ps_category_image_url: base_url.media_server_url + '/newsletters/StoreBanners/TopnavBanners/collections'
}

const image_size_constants = {
    thumbnail_desktop: "75X108.",
    plp_desktop: "240X368.",
    //pdp_desktop: "300X460.",
    //pdp_mobile: "800X1220."
}

const debounce = 0

const limitOffset = 32
const saleId = 49

const getReasonToChooseUs = (selectedLang) => {
	const reasonToChooseUs = [
		{
			imageSrc : flexibleImg,
			header: language[selectedLang].flexible_terms,
			content: language[selectedLang].custom_loan
		},
		{
			imageSrc : speedImg,
			header: language[selectedLang].quick_disbursement,
			content: language[selectedLang].receive_loan
		},
		{
			imageSrc : deleteDocImg,
			header: language[selectedLang].paper_work,
			content: language[selectedLang].paper_docs
		},
		{
			imageSrc : customerImg,
			header: language[selectedLang].customer_focused,
			content: language[selectedLang].customer_service
		},
		{
			imageSrc : dataProtectImg,
			header: language[selectedLang].data_security,
			content: language[selectedLang].secured_ssl
		},
	]
	return reasonToChooseUs
}

const getHowItWorks = (selectedLang) => {
	const howItWorks = [
		{
			imageSrc : formImg,
			header: language[selectedLang].send_enquiry,
			content: language[selectedLang].online_application
		},
		{
			imageSrc : kycImg,
			header: language[selectedLang].quick_verification,
			content: language[selectedLang].quick_ekyc
		},
		{
			imageSrc : uploadImg,
			header: language[selectedLang].upload_documents,
			content: language[selectedLang].scan_documents
		},
		{
			imageSrc : cashImg,
			header: language[selectedLang].loan_sanction,
			content: language[selectedLang].loan_approval
		},
	]
	return howItWorks
}

const CONTACT_US = '8741092723'


const LOAN_TYPES = {
	E_RICKSHAW: 'E-Rickshaw',
	ELECTRIC_AUTO: 'Electric Auto',
	ELECTRIC_4_WHEELER: 'Electric 4 Wheeler',
}

const INTEREST_TYPE = [
	{ name: 'Reducing', value: 'Reducing' },
	{ name: 'Flat', value: 'Flat' },
  ]

export {
    media_base_url,
    image_size_constants,
    debounce,
    limitOffset,
    saleId,
		getReasonToChooseUs,
		getHowItWorks,
	CONTACT_US,
	LOAN_TYPES,
	INTEREST_TYPE
}



// WEBPACK FOOTER //
// ./src/constants/common.js